export default "__VITE_ASSET__OwGTu5Uc__"